import type { NextPage } from "next";
import Head from "next/head";
import { useMemo } from "react";

import defiJSON from "@data/defi.json";
import { PageProvider } from "@providers/page";
import DefiV2 from "@components/defi-v2/DefiV2";

const DefiPageV2: NextPage = () => {
  const { pools, allTags } = defiJSON;
  const getHeader = useMemo(() => {
    return (
      <Head>
        <title>Kelp</title>
        <meta name="description" content="Kelp" />
        <link rel="icon" href="/favicon.ico" />
        <meta name="robots" content="index, follow" />
      </Head>
    );
  }, []);

  return (
    <PageProvider value={{ pageData: { allTags, pools } }}>
      {getHeader}

      <DefiV2 />
    </PageProvider>
  );
};

export default DefiPageV2;
